import { html } from "lit-html";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";

export interface Props {
	checkboxChecked: boolean;
	checkboxLabel: string;
	inputLabel: string;
	inputValue: string;
	justify?: "start" | "end";
	onCheckboxClick: () => void;
	onInput: (value: string) => void;
}

export const name = "admin-checkbox-input";

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		checkboxChecked: host.checkboxChecked || false,
		checkboxLabel: host.checkboxLabel || "",
		inputLabel: host.inputLabel || "",
		inputValue: host.inputValue || "",
		justify: host.justify,
		onCheckboxClick: host.onCheckboxClick || (() => {}),
		onInput: host.onInput || (() => {}),
	};

	const handleInput = (e: InputEvent) => {
		const value = (e.target as HTMLInputElement).value;
		props.onInput(value);
	};

	const checkboxTemplate = () => html`
		<div class="pt-7">
			<admin-checkbox
				.checked=${props.checkboxChecked}
				.justify=${props.justify}
				.label=${props.checkboxLabel}
				.onClick=${props.onCheckboxClick}
			></admin-checkbox>
		</div>
	`;

	return html`
		<div class="mt-4 grid select-none grid-cols-[2fr_3fr] gap-4">
			${checkboxTemplate()}

			<div class="w-full">
				<label class="mb-1 block text-sm">${props.inputLabel}</label>
				<input
					class="flex h-10 w-full appearance-none items-center rounded-lg border border-solid border-black px-4"
					type="text"
					value=${props.inputValue || ""}
					@input=${handleInput}
				/>
			</div>
		</div>
	`;
};
